<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex class="d-flex align-center justify-space-between" xs12 mt-3>
          <h1 class="headline">{{ $t('autos.title') }}</h1>
          <v-btn
            v-if="$can('investor_car_internal_maintenance_show')"
            :to="{ name: 'investor-internal-maintenance' }"
            color="info mt-2 mr-3"
            depressed
            large
          >
            {{ $t('auto.internalMaintenance') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex
          xs12
          sm12
          md7
          lg6
          mt-4
          :class="{ 'mt-4': $vuetify.breakpoint.mdAndUp }"
        >
          <v-layout wrap align-center class="search search-wrapper">
            <v-text-field
              ref="search"
              v-model="search"
              :placeholder="$t('investor-auto.placeholder')"
              autocomplete="off"
              solo
              hide-details
            />
            <v-btn
              type="button"
              class="search-btn warning"
              depressed
              large
              @click="filters.searchString = search"
            >
              {{ $t('common.btns.search') }}
            </v-btn>
          </v-layout>
        </v-flex>
        <v-flex
          xs12
          sm12
          :class="{ 'mt-4': $vuetify.breakpoint.mdAndUp }"
          class="filter-wrapper mb-4"
        >
          <div class="d-flex">
            <v-select
              :items="autosStatuses"
              v-model="filters.autoStatus"
              :label="$t('common.fields.status')"
              :placeholder="$t('autos.allAutos')"
              item-text="title"
              item-value="id"
              class="filter"
              clearable
              :loading="filtersLoading"
            ></v-select>
            <v-select
              :items="rates"
              v-model="filters.rentRate"
              :label="$t('rates.title')"
              :placeholder="$t('rates.all')"
              item-text="name"
              item-value="id"
              class="filter ml-5"
              clearable
              :loading="filtersLoading"
            ></v-select>
            <v-select
              :items="tableParks"
              v-model="filters.carParkId"
              :label="$t('employees.park')"
              :placeholder="$t('parks.all')"
              item-text="name"
              item-value="id"
              class="filter ml-5"
              clearable
              :loading="filtersLoading"
            ></v-select>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="autosListData.items"
        :loading="loading"
        :items-per-page="-1"
        hide-default-footer
      >
        <template #[`item.number`]="{ item }">
          <v-btn color="warning" text small :to="`/autos/${item.id}/info`">
            {{ item.number }}
          </v-btn>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: () => ({
    loading: false,
    filtersLoading: false,
    search: '',
    filters: {
      searchString: '',
      rentRate: '',
      carParkId: '',
      autoStatus: '',
    },
  }),
  watch: {
    filters: {
      immediate: true,
      deep: true,
      handler(params) {
        this.fetchList(params);
      },
    },
  },
  computed: {
    ...mapState({
      autosStatuses: ({ auto }) => auto.autosStatuses,
      autosListData: ({ auto }) => auto.autosListData,
      rates: ({ rates }) => rates.list,
      parks: ({ parks }) => parks.list,
    }),
    tableParks() {
      return this.parks.filter(({ id }) => {
        const itemsList = this.autosListData.items || [];
        return itemsList.some((item) => item.park_id === id);
      });
    },
    headers() {
      return [
        {
          text: this.$t('common.number'),
          value: 'num',
          sortable: false,
        },
        {
          text: this.$t('autosList.tableHeaders.number'),
          value: 'number',
          sortable: false,
        },
        {
          text: this.$t('autosList.tableHeaders.brand'),
          value: 'brand',
          sortable: true,
        },
        {
          text: this.$t('autosList.tableHeaders.model'),
          value: 'model',
          sortable: true,
        },
        {
          text: this.$t('autosList.tableHeaders.year'),
          value: 'year',
          sortable: true,
        },
        {
          text: this.$t('autosList.tableHeaders.company'),
          value: 'company',
          sortable: false,
        },
        {
          text: this.$t('autosList.tableHeaders.status'),
          value: 'status',
          sortable: false,
        },
        {
          text: this.$t('employees.park'),
          value: 'park_name',
          sortable: false,
        },
        {
          text: this.$t('rates.title'),
          value: 'rent_rate_name',
          sortable: false,
        },
      ];
    },
  },
  methods: {
    async fetchList(params) {
      this.loading = true;
      await this.$store.dispatch('auto/fetchAutosListData', params);
      this.loading = false;
    },
  },
  async created() {
    this.filtersLoading = true;
    await Promise.all([
      this.$store.dispatch('auto/fetchAutosProperties'),
      this.$store.dispatch('rates/fetchList'),
      this.$store.dispatch('parks/fetchList'),
    ]);
    this.filtersLoading = false;
  },
};
</script>

<style>
.search {
  max-width: 480px !important;
}
</style>
